var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10.3098C2.00037 10.0701 2.06226 9.83447 2.17973 9.62551C2.29721 9.41656 2.46634 9.24125 2.67095 9.11637L14.6065 1.82141L26.542 9.11637C26.7466 9.24125 26.9158 9.41656 27.0332 9.62551C27.1507 9.83447 27.2126 10.0701 27.213 10.3098V24.2329C27.213 24.6044 27.0654 24.9607 26.8027 25.2234C26.54 25.4861 26.1837 25.6337 25.8123 25.6337H3.40072C3.02923 25.6337 2.67295 25.4861 2.41026 25.2234C2.14758 24.9607 2 24.6044 2 24.2329V10.3098Z",
    stroke: "#03014C",
    strokeWidth: 2.80144
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.9261L14.6065 18.6301L27.213 10.9261",
    stroke: "#03014C",
    strokeWidth: 2.80144,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/EmailLogo.e624e7d2c4a46ac177ef1f3db71340ba.svg";
export { ForwardRef as ReactComponent };